export default __webpack_public_path__ + "static/media/banner.fe53f618.jpeg";